import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import { FeaturedProduct } from 'types';
import { useTranslation, Trans } from 'react-i18next';
import { useCurrency } from './Product.utils';
import {
  Wrapper,
  Button,
  Content,
  Title,
  Thumbnail,
  Price,
  PriceWrapper,
  OldPrice,
  OldPriceTitle,
  OldPriceWrapper,
  TitleWrapper,
  BestPriceTitle,
  Logo,
} from './Product.style';

interface ProductProps {
  data: FeaturedProduct;
}

const Product: FunctionComponent<ProductProps> = ({
  data: {
    name,
    promotionalPrice,
    loyaltyPrice,
    thumbnailUrl,
    regularPrice,
    productUrl,
    producent,
  },
  ...props
}) => {
  const { t } = useTranslation();
  const currency = useCurrency();

  return (
    <Wrapper {...props}>
      <Content
        container
        direction="column"
        alignItems="center"
        justify="space-between"
        wrap="nowrap"
      >
        <Grid container direction="column" alignItems="flex-start">
          {producent && producent.logoUrl && (
            <Logo style={{ backgroundImage: `url('${producent.logoUrl}')` }} />
          )}
          <Thumbnail style={{ backgroundImage: `url('${thumbnailUrl}')` }} />
          <TitleWrapper>
            <Title>{name}</Title>
          </TitleWrapper>
          <PriceWrapper>
            <BestPriceTitle>
              <Trans
                t={t}
                components={{ highlight: <span /> }}
                i18nKey="LOYALTY_PRICE"
              />
            </BestPriceTitle>
            <Price>{`${loyaltyPrice.toFixed(2)} ${currency}`}</Price>
          </PriceWrapper>
          {promotionalPrice ? (
            <OldPriceWrapper>
              <OldPriceTitle>{t('RETAIL_PRICE')}</OldPriceTitle>
              <OldPrice>
                {`${promotionalPrice.toFixed(2)} ${currency}`}{' '}
              </OldPrice>
            </OldPriceWrapper>
          ) : null}
          {regularPrice ? (
            <OldPriceWrapper>
              <OldPriceTitle>{t('SUGGESTED_PRICE')}</OldPriceTitle>
              <OldPrice>{`${regularPrice.toFixed(2)} ${currency}`} </OldPrice>
            </OldPriceWrapper>
          ) : null}
        </Grid>
        <Button
          onClick={
            productUrl ? () => window.open(productUrl, '_blank') : undefined
          }
        >
          {t('OFFER_DETAILS')}
        </Button>
      </Content>
    </Wrapper>
  );
};

export default Product;
